module.exports = __webpack_public_path__ + "static/media/video_player.45d59261.svg";


//////////////////
// WEBPACK FOOTER
// ./src/statics/images/video_player.svg
// module id = ./src/statics/images/video_player.svg
// module chunks = 0